import {
  MedicalHistoryQuestionsBase,
  PatientMedicalHistoryQuestionBase,
} from "../../../../../backend/src/graph/patient_medical_histories/medical-history-questions-base";
import forOwn from "lodash/forOwn";
import { Subject } from "rxjs";

export class MedicalHistoryQuestionEntry extends PatientMedicalHistoryQuestionBase {
  public show = true;
  public onQuestionConfirmed = new Subject<boolean>();

  public toBase(): PatientMedicalHistoryQuestionBase {
    const newBase = new PatientMedicalHistoryQuestionBase();
    newBase.details = this.details;
    newBase.follow_up_question = this.follow_up_question;
    newBase.position = this.position;
    newBase.question_id = this.question_id;
    newBase.text = this.text;
    newBase.value = this.value;
    return newBase;
  }

  constructor(baseItem?: PatientMedicalHistoryQuestionBase) {
    super();
    if (!baseItem) return;
    forOwn(baseItem, (value, key) => {
      if (key === "details") this.details = String(value || "");
      else this[key] = value;
    });
  }

  public set confirmed(confirmed: boolean) {
    this.onQuestionConfirmed.next(confirmed);
  }
}

export class MedicalHistoryQuestionsEntry extends MedicalHistoryQuestionsBase {
  public dateOfBirth: string;
  public questions: Array<MedicalHistoryQuestionEntry>;
  public encoded_signature: string;
  public signature_used: string;

  constructor(baseItem?: MedicalHistoryQuestionsBase) {
    super();
    if (!baseItem) return;
    forOwn(baseItem, (value, key) => {
      this[key] = value;
    });

    this.questions = new Array<MedicalHistoryQuestionEntry>();
    for (const question of baseItem.questions) {
      this.questions.push(new MedicalHistoryQuestionEntry(question));
    }
  }
}
